<template lang="html">
  <div id="js-notif" class="notifications">
    <div class="notifications-container">
      <transition-group name="notification">
        <div
          class="notification has-shadow-2"
          v-for="(toast, index) in toasters"
          :class="toast.state"
          :key="index">

          <span
            class="close pa-6"
            v-on:click="close(index)">
          </span>

          <p class="ticket">{{ toast.title }}</p>
          <p class="text">{{ toast.text }}</p>
          <a class="more"
            v-on:click.stop
            v-if="toast.link"
            :href="toast.link"
            target='_blank'>{{ $t('components.toasters.more') }}
          </a>
        </div>
      </transition-group>
    </div>
  </div>

</template>

<script lang="js">

import { eventHubMixin } from '@/mixins/event';

export default {
  name: 'Toasters',
  mixins: [eventHubMixin],
  mounted() {
    this.eventHub.$on('toaster:add', (toast) => {
      this.create(toast);
    });
  },
  data() {
    return {
      toasters: [],
    };
  },
  methods: {
    close(index) {
      this.toasters.splice(index, 1);
    },
    create(toast) {
      this.toasters.push(toast);
    },
  },
};
</script>
